import { render, staticRenderFns } from "./newPhone.vue?vue&type=template&id=68177c94"
import script from "./newPhone.vue?vue&type=script&lang=js"
export * from "./newPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports